export default __webpack_public_path__ + "static/media/nivo.82eab290.png";